module.exports = __webpack_public_path__ + "img/production-issues.26832d8c.png";